import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import React, { useEffect, useState } from 'react';
import './ImageManagementTask.scss';
import ImageManagementResults, { ResultHandle } from './Results';
import TaskOption from './TaskOption';
import { updateImageTaskResultsList, useUpdateIsPreview } from './hooks';
enum TabNames {
  TASK_OPTIONS = 'TaskOptions',
  RESULT = 'Results',
}

const ImageManagementTask = () => {
  const [selectedOption, setSelectedOption] = useState<TabNames>(TabNames.TASK_OPTIONS);
  const resultRef = React.useRef<ResultHandle>();
  const onUpdateImageTasksResultList = updateImageTaskResultsList();
  const setIsPreview = useUpdateIsPreview();

  const tabComponents: ITabItem[] = [
    {
      title: 'Task Option',
      eventKey: TabNames.TASK_OPTIONS,
      content: <TaskOption setSelectedTab={setSelectedOption} />,
      tabClassName: 'max-w-[9%] w-[9%] h-[100%] flex justify-center',
    },
    {
      title: 'Results',
      eventKey: TabNames.RESULT,
      content: <ImageManagementResults ref={resultRef} />,
      tabClassName: 'max-w-[9%] w-[9%] h-[100%] flex justify-center',
    },
  ];

  const tabs = (
    <RMTabs
      id="imagemanagementtask-tab-container"
      tabItems={tabComponents}
      defaultActiveKey={TabNames.TASK_OPTIONS}
      activeKey={selectedOption}
      onSelect={setSelectedOption}
      className="customTab tabTitleContainer h-[8%]"
    />
  );

  useEffect(() => {
    return () => {
      onUpdateImageTasksResultList([]);
      setIsPreview(false);
    };
  }, []);

  return (
    <div id="imagemanagementtask-wrapper" className="container-fluid border">
      <div id="imagemanagementtask-tab" className="row h-[100%]">
        <div id={`imagemanagementtask-${tabs}-container`} className="col-md-12 h-[100%]">
          {tabs}
        </div>
      </div>
    </div>
  );
};

export default ImageManagementTask;
